import { render } from "./textComponent.vue?vue&type=template&id=58e6d660"
import script from "./textComponent.vue?vue&type=script&lang=js"
export * from "./textComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__